var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"badge badge-pill font-size-16 mr-2 mb-2",class:_vm.spanClasses,attrs:{"title":_vm.title},on:{"click":_vm.emitClick}},[(_vm.toggleEnabled)?_c('v-svg',{staticClass:"icon-sm",class:{
      'icon-primary': !_vm.selected,
      'icon-white': _vm.selected,
    },attrs:{"code":_vm.iconCode}}):_vm._e(),_vm._v(" "+_vm._s(_vm.tag.name))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }